// extracted by mini-css-extract-plugin
module.exports = {"grey":"#4B5766","blue":"#005CFF","moving":"NavSpecial_moving__JYs_O","active":"NavSpecial_active__29wCR"};